"use client"

import { queryClient } from "@/lib/api/_common/queryClient"
import { QueryClientProvider } from "@tanstack/react-query"

export function TanstackQueryClientProvider({
    children,
}: { children: React.ReactNode }) {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    )
}
